// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, anyOf } from "@altostra/type-validations";
import { string, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

export const isCdiSyncJob = objectOf({
  job_run_id: string,
  integration_id: string,
  job_status: string,
  job_start_time: string,
  job_finish_time: string,
  job_errors: nullOrUndefined,
  start_sync_timestamp: anyOf(string, nullOrUndefined),
  finish_sync_timestamp: string,
  rows_read: number,
  rows_ingested: number,
  rows_rejected_in_read: number,
  rows_rejected_in_ingest: number,
  error_sentinels_produced: number,
  s3_file_path: maybe(anyOf(string, nullOrUndefined)),
});
